<div data-cy="unknown_page">
  <section class="layout-content mt">
    <assessment-text-desc></assessment-text-desc>
  </section>
  <unknown-retry *ngIf="!hasRetried" (retryChange)="onRetry($event)"></unknown-retry>

  <unknown-has-retried *ngIf="hasRetried"></unknown-has-retried>
</div>
